import moment, { Moment } from 'moment'
import { useEffect, useState } from 'react'

interface UseTimeOptions {
  /** Default refresh interval is 1000ms (1 second). */
  refreshIntervalMs?: number
}

export const useTime = (options?: UseTimeOptions): Moment => {
  const [time, setTime] = useState<Moment>(moment())

  useEffect(() => {
    const intervalId = setInterval(() => setTime(moment()), options?.refreshIntervalMs || 1000)
    return () => clearInterval(intervalId)
  }, [options])

  return time
}
